var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}]},[_c('div',{class:[_vm.baseClass],domProps:{"innerHTML":_vm._s(_vm.videoData.code)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }